document.addEventListener('DOMContentLoaded', () => {
  const forms = [...document.querySelectorAll('[data-mm-product-form]')];

  forms.forEach((form) => {
    const idInput = form.querySelector('[name="id"]');
    const submit = form.querySelector('[type="submit"]');
    const note = form.querySelector('[data-mm-form-note]');
    const buyCard = form.closest('[data-mm-buy]');
    const demand = buyCard?.querySelector('[data-mm-demand]');
    const demandLabel = buyCard?.querySelector('[data-mm-demand-label]');
    const demandTags = buyCard?.querySelector('[data-mm-demand-tags]');
    const demandEmail = buyCard?.querySelector('#MmDemandEmail');
    const variantButtons = [...form.querySelectorAll('[data-mm-variant]')];
    const demandButtons = [...form.querySelectorAll('[data-mm-demand-size]')];
    const allSizeButtons = [...variantButtons, ...demandButtons];

    variantButtons.forEach((button) => {
      button.addEventListener('click', () => {
        allSizeButtons.forEach((item) => item.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', 'true');
        idInput.value = button.dataset.mmVariant;
        if (demand) demand.hidden = true;
        if (note) note.textContent = `${button.dataset.title} ausgewählt`;
      });
    });

    demandButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const size = button.dataset.mmDemandSize;
        allSizeButtons.forEach((item) => item.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', 'true');
        if (demandLabel) demandLabel.textContent = size;
        if (demandTags) demandTags.value = `newsletter,groesseninteresse-longsleeve-${size.toLowerCase()}`;
        if (demand) demand.hidden = false;
        if (note) note.textContent = `Größe ${size} ist noch nicht verfügbar. Du kannst sie jetzt vormerken.`;
        demand?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        window.setTimeout(() => demandEmail?.focus(), 350);
      });
    });

    buyCard?.querySelector('[data-mm-demand-close]')?.addEventListener('click', () => {
      if (demand) demand.hidden = true;
      demandButtons.forEach((item) => item.setAttribute('aria-pressed', 'false'));
    });

    if (buyCard?.querySelector('[data-mm-demand-success]') && demand) {
      demand.hidden = false;
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!idInput.value) {
        if (note) note.textContent = 'Bitte wähle zuerst eine Größe.';
        return;
      }

      submit.disabled = true;
      submit.textContent = 'Wird hinzugefügt …';

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('add_failed');
        window.location.assign(window.Shopify.routes.root + 'cart');
      } catch (error) {
        if (note) note.textContent = 'Das hat nicht geklappt. Bitte versuche es erneut.';
        submit.textContent = 'Erneut versuchen';
        submit.disabled = false;
      }
    });
  });
});
